/**
 *
 * StyledConfiguratorTab
 *
 */
import React from 'react';
import styled from 'styled-components/macro';
// eslint-disable-next-line no-restricted-imports
import { css } from 'styled-components';

const StyledConfiguratorTab = styled.button<{
  isActive?: boolean;
  mobile?: number;
}>`
  //background-color: #c4c4c4;
  color: ${p => p.theme.gray700};
  //border-radius: 0.25rem;
  //border-top-left-radius: 9999px;
  //border-top-right-radius: 9999px;
  padding: 0.25rem 2.5rem;
  border-width: 1px;
  font-size: 1.125rem;
  font-weight: 500;
  background-color: white;
  height: 40px;

  ${p =>
    p.isActive
      ? css`
          background-color: #f3f2f1;
          color: rgb(45, 55, 72);
          cursor: default;
          border-width: 0px;
        `
      : css`
          &:hover {
            background-color: ${p => p.theme.hover};
            border-width: 1px;
          }
        `}

  ${p =>
    p.mobile &&
    css`
      padding: 0.25rem 2rem;

      @media (max-width: 380px) {
        padding: 0.25rem 1.5rem;
      }
      @media (max-width: 360px) {
        padding: 0.25rem 1.3rem;
      }
      flex-grow: 1;
    `}
`;

export default StyledConfiguratorTab;
